window.addEventListener("DOMContentLoaded", () => {
  switch (WindCreekData.propertyName) {
    case 'Atmore':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'fbf73cda-1fcb-4b9b-a956-75220737cf8e',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'Bethlehem':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'e41b183a-a81a-4cf2-99b5-ef4a3ca1e90e',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'Chicago Southland':
      if (WindCreekData.pagePath !== 'page-chicagosouthland-open-fall-2024') {

        (function (n, u) {

          let e;

          window.CXoneDfo = n,

            window[n] = window[n] || function () {(window[n].q = window[n].q || []).push(arguments);}, window[n].u = u,

            e = document.createElement("script"), e.type = "module", e.src = u + "?" + Math.round(Date.now() / 1e3 / 3600),

            document.head.appendChild(e);

        })('cxone', 'https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');

        cxone('init', '3752');

        cxone('guide', 'init', '01367d0a-2873-41bf-a4d6-39c198d67325');

      }

      break;
    case 'Montgomery':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'3f106c19-8bd3-443d-a992-88bec108a72a',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'WaSheShu':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'c0b8edaa-32c2-475c-b6fa-964f6a6166e0',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'Wetumpka':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'006f6141-6a7b-4d19-9a00-419d628aae58',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'Aruba':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'32f26fb4-147b-4f72-ba7d-7e9c94c29e36',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'Curacao':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'a7b5cb8b-6cd4-4681-9c87-406a49bf64be',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
  }
});
